import { Controller, useFormContext } from "react-hook-form";
import { PasswordInput, PasswordInputProps } from "./password-input";

export type ControlledPasswordInputProps = Omit<
  PasswordInputProps,
  "onValueChange" | "errorMessage"
> & {
  name: string;
};

export function ControlledPasswordInput(props: ControlledPasswordInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => {
        return (
          <PasswordInput
            {...field}
            onValueChange={field.onChange}
            {...props}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error?.message}
            value={field.value ?? ""}
          />
        );
      }}
    />
  );
}

ControlledPasswordInput.displayName = "RecareUI.ControlledPasswordInput";
